import React, { FC, useEffect, useState } from "react";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate, useParams } from "react-router-dom";
import { Button, IconButton } from "@mui/material";
import axios from "axios";

import { baseServiceUrl, urls } from "../../environment";

import ExamNewImg from "../../assets/examNew.png";
import { ResultDetailsTypes, ResultSummaryMainTypes } from "../../interfaces/question.interface";
import toast from "react-hot-toast";
import moment from "moment";
import { TweleveHourFormat } from "../../utils";
import Sidebar from "../../components/Sidebar";
import PDFViewer from "../../components/PDFViewer";
import { CancellationReasonTypes } from "../../interfaces/exams.interface";
import useUserStore from "../../stores/useUserStores";

type ResultSectionProps = {};
const ResultSection: FC<ResultSectionProps> = (): JSX.Element => {
  const Navigate = useNavigate();
  const [side, setside] = useState<boolean>(false);
  const [apiLoading, setAPILoading] = useState<boolean>(false);

  const [cancellationDetails, setCancellationDeatails] = useState<
    Array<CancellationReasonTypes>
  >([]);
  const userDetails: any = useUserStore();
  const [examResultDetails, setExamResultDetails] = useState<any | null>(null);
  const params = useParams();

  // useEffect(() => {
  //   if (!userDetails.selectedExamGroup) return;
  //   (async () => {
  //     try {
  //       userDetails.setLoading(true);
  //       // setAPILoading(true);
  //       const response = await axios.post(
  //         baseServiceUrl + urls.examineeResult,
  //         {
  //           exam_id: userDetails.selectedExamGroup,
  //           user_id: userDetails.userdetail?.id,
  //         },
  //         {
  //           headers: {
  //             Authorization: "Bearer " + userDetails.token,
  //           },
  //         }
  //       );
  //       if (response.data) {
  //         setExamResultDetails(response.data);
  //       }
  //     } catch (err: any) {
  //       console.log("err: ", err);
  //       toast.error(
  //         err?.response?.data?.message || "Error encounter. Please try again."
  //       );
  //     } finally {
  //       setAPILoading(false);
  //     }
  //   })();
  // }, [userDetails, userDetails.selectedExamGroup]);

  useEffect(() => {
    if (
      !params ||
      !params?.id ||
      !userDetails ||
      !userDetails?.userdetail ||
      !userDetails.userdetail?.id
    )
      return;
    (async () => {
      try {
        const response = await axios.post(
          baseServiceUrl + urls.examiniResult,
          {
            user_id: userDetails?.userdetail.id,
            exam_id: Number(params.id),
          },
          {
            headers: {
              Authorization: "Bearer " + userDetails.token,
            },
          }
        );
      } catch (error: any) {}
    })();
  }, [params, userDetails]);

  useEffect(() => {
    if (
      !params ||
      !params?.id ||
      !userDetails ||
      !userDetails?.userdetail ||
      !userDetails.userdetail?.id
    )
      return;
    (async () => {
      try {
        const response = await axios.post(
          baseServiceUrl + urls.examiniResultSummary,
          {
            exam_id: Number(params.id),
            user_id: Number(userDetails.userdetail?.id),
          },
          {
            headers: {
              Authorization: "Bearer " + userDetails.token,
            },
          }
        );
        setExamResultDetails(response.data);
      } catch (error: any) {
        toast.error(error?.response?.data?.message);
      }
    })();
  }, [params?.id, userDetails]);
  const handleSide = () => {
    setside((prev) => !prev);
  };
  const navigate = useNavigate();
  return (
    <div>
      <div className=" flex">
        <div className="fixed top-0 left-0 lg:w-[280px]  min-h-[100vh]">
          <Sidebar side={side} handleside={handleSide} />
        </div>
        <div className=" w-[100vw] min-h-[100vh] ml-[280px]  ">
          <div className="  relative">
            <div className="md:ml-[10vw] mt-4">
              <IconButton
                onClick={() => navigate("/Dashboard/test-series")}
                className=""
              >
                <ArrowBackIosNewIcon />
              </IconButton>
            </div>
            <div className=" mt-2 w-full   flex items-center justify-center relative">
              {/* <div className="absolute top-2 left-4">
                <Button
                  startIcon={<HomeIcon />}
                  variant="outlined"
                  className="font-bold "
                  onClick={() => Navigate(-1)}
                >
                  Go back
                </Button>
              </div> */}

              {/* <div className="md:w-1/2 xl:w-[45%]   md:mt-12   ">
                <div className="w-full h-full px-5 py-2 bg-[#006766]  shadow-md">
                  <div className="text-white flex  items-center gap-x-2  ">
                    <p className="text-sm col-span-2 min-w-[10%] ">
                      EXAM NAME :
                    </p>
                    <p className="text-xl font-semibold col-span-9">
                      {examResultDetails?.result_summary?.title}
                    </p>
                  </div>
                  <div className="text-white  flex  items-center gap-x-2  ">
                    <p className="text-sm col-span-2 min-w-[10%] ">DATE :</p>
                    <p className="text-xl font-semibold col-span-9">
                      {examResultDetails?.result_summary?.current_date}
                    </p>
                  </div>
                  <div className="text-white  flex  items-center gap-x-2  ">
                    <p className="text-sm col-span-2 min-w-[10%] ">ROLL NO.</p>
                    <p className="text-xl font-semibold col-span-9">
                      {examResultDetails?.result_summary?.roll_no}
                    </p>
                  </div>
                </div>
                <div className="md:px-5 mt-10">
                  <div className="w-full h-full py-2 text-center text-3xl text-[#006766]">
                    EXAMINATION RESULT
                  </div>
                  <div className="text-[#006766]  md:mt-6 xl:mt-10 text-lg font-bold  border-b-4 border-yellow-400 ">
                    CANDIDATE DETAILS
                  </div>
                  <div className="mt-3 w-full grid grid-cols-12 gap-[2px]">
                    <div className="col-span-3  bg-[#006766] px-2 text-white uppercase">
                      NAME
                    </div>
                    <div className="col-span-2  bg-[#006766] px-2 text-white uppercase">
                      DATE OF BIRTH
                    </div>

                    <div className="col-span-3  bg-[#006766] px-2 text-white uppercase">
                      ROLL NO.
                    </div>
                    <div className="col-span-4  bg-[#006766] px-2 text-white uppercase">
                      REGISTRATION NO.
                    </div>
                    <div className="col-span-3  bg-gray-200 px-2 text-black uppercase">
                      {examResultDetails?.result_summary?.full_name}
                    </div>
                    <div className="col-span-2  bg-gray-200 px-2 text-black uppercase">
                      {examResultDetails?.result_summary?.dob
                        ? moment(examResultDetails?.result_summary.dob).format(
                            "DD-MMM-YYYY"
                          )
                        : "N/A"}
                    </div>

                    <div className="col-span-3  bg-gray-200 px-2 text-black">
                      {examResultDetails?.result_summary?.roll_no}
                    </div>
                    <div className="col-span-4  bg-gray-200 px-2 text-black">
                      {examResultDetails?.result_summary?.registration_no}
                    </div>
                  </div>
                  <div className="text-[#006766] text-lg font-bold  border-b-4 border-yellow-400 md:mt-6 xl:mt-8 ">
                    CONTACT DETAILS
                  </div>
                  <div className="mt-3">
                    <div className="flex items-center">
                      <p className="font-[700] w-[20%]">EMAIL ID</p>
                      <p className="  ">
                        {examResultDetails?.result_summary?.email ?? "N/A"}
                      </p>
                    </div>
                    <div className="flex items-center">
                      <p className="font-[700] w-[20%]">PHONE NUMBER</p>
                      <p className="  ">
                        {examResultDetails?.result_summary?.phone ?? "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="text-[#006766]  text-lg font-bold  border-b-4 border-yellow-400 md:mt-6 xl:mt-8 ">
                    EXAMINATION SUMMARY
                  </div>
                  <div className="mt-3  w-full grid grid-cols-10 gap-[2px] ">
                    <div className="text-white bg-[#006766] col-span-2 uppercase pl-2 py-[2px] text-sm">
                      exam date
                    </div>
                    <div className="text-white col-span-2 bg-[#006766] uppercase pl-2 py-[2px] text-sm">
                      venue code
                    </div>
                    <div className="text-white col-span-2 bg-[#006766] uppercase pl-2 py-[2px] text-sm">
                      exam slot
                    </div>
                    <div className="text-white col-span-2 bg-[#006766] uppercase pl-2 py-[2px] text-sm">
                      total questions
                    </div>
                    <div className="text-white col-span-2 bg-[#006766] uppercase pl-2 py-[2px] text-sm">
                      total marks
                    </div>
                  </div>
                  <div className="  w-full grid grid-cols-10 gap-[2px] ">
                    <div className="text-black bg-gray-200 col-span-2 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails?.result_summary?.exam_date ?? "N/A"}
                    </div>
                    <div className="text-black col-span-2 bg-gray-200 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails?.result_summary?.center_id ?? "N/A"}
                    </div>
                    <div className="text-black col-span-2 bg-gray-200 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails &&
                      examResultDetails?.result_summary?.start_time
                        ? `${TweleveHourFormat(
                            examResultDetails?.result_summary?.start_time
                          )} - ${TweleveHourFormat(
                            examResultDetails?.result_summary?.end_time
                          )} `
                        : "N/A"}
                    </div>
                    <div className="text-black col-span-2 bg-gray-200 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails?.result_summary?.total_questions}
                    </div>
                    <div className="text-black col-span-2 bg-gray-200 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails?.result_summary?.total_marks}
                    </div>
                  </div>

                  <div className="text-[#006766]  text-lg font-bold  border-b-4 border-yellow-400 md:mt-5 xl:mt-10 ">
                    RESULT
                  </div>
                  <div className="mt-3  w-full grid grid-cols-12 gap-[2px] ">
                    <div className="text-white bg-[#006766] col-span-2 uppercase pl-2 py-[2px] text-[12px]">
                      total questions attempted
                    </div>
                    <div className="text-white bg-[#006766] col-span-2 uppercase pl-2 py-[2px] text-[12px]">
                      total questions not attempted
                    </div>
                    <div className="text-white col-span-2 bg-[#006766] uppercase pl-2 py-[2px] text-[12px]">
                      correct answer
                    </div>
                    <div className="text-white col-span-2 bg-[#006766] uppercase pl-2 py-[2px] text-[12px]">
                      incorrect answer
                    </div>
                    <div className="text-white col-span-2 bg-[#006766] uppercase pl-2 py-[2px] text-[12px]">
                      marks obtained
                    </div>
                    <div className="text-white col-span-2 bg-[#006766] uppercase pl-2 py-[2px] text-[12px]">
                      total marks
                    </div>
                  </div>
                  <div className="  w-full grid grid-cols-12 gap-[2px] ">
                    <div className="text-black bg-gray-200 col-span-2 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails?.result_summary?.total_attempt}
                    </div>
                    <div className="text-black col-span-2 bg-gray-200 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails
                        ? examResultDetails?.result_summary?.not_attempted
                        : "N/A"}
                    </div>
                    <div className="text-black col-span-2 bg-gray-200 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails
                        ? examResultDetails?.result_summary?.total_correct
                        : "N/A"}
                    </div>
                    <div className="text-black col-span-2 bg-gray-200 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails
                        ? examResultDetails?.result_summary?.total_incorrect
                        : "N/A"}
                    </div>
                    <div className="text-black col-span-2 bg-gray-200 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails
                        ? examResultDetails?.result_summary?.obtain_marks
                        : "N/A"}
                    </div>
                    <div className="text-black col-span-2 bg-gray-200 uppercase pl-2 text-sm py-[2px]">
                      {examResultDetails
                        ? examResultDetails?.result_summary?.total_marks
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <PDFViewer/> */}
              {/* <PDFViewer fileUrl={"http://www.pdf995.com/samples/pdf.pdf"}/> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultSection;
